/**
 * Bankame Widget — Integración con Shopify (BLOOM BOX)
 * v1.0.0-bloombox — fork de la v3.4.0 de Sarango.
 *
 * DIFERENCIAS CON SARANGO (todo lo demás se mantiene igual):
 *
 *   1. PRECIO SEGÚN EL FLUJO. Sarango cotiza siempre al precio de lista.
 *      Bloom Box no: en cuotas va el precio de lista y al contado va el
 *      precio con descuento. Ver precioParaFlujo(). Los details que recibe
 *      el SDK siguen llevando los dos precios (unitPrice / discountPrice),
 *      así que el panel también puede decidir por su lado; esta regla es la
 *      que se aplica al crear la orden en Shopify, para que la orden diga lo
 *      que realmente se cobró.
 *
 *   2. ENVÍO CALCULADO POR SHOPIFY. Sarango toma payload.shippingCost del
 *      widget. Acá se consulta /cart/shipping_rates.json con la dirección
 *      del cliente y se usa esa tarifa. Sigue viajando en shipping_cost,
 *      aparte de items, para que la comisión se calcule solo sobre los
 *      productos.
 *
 *   3. DRAWER. El tema tiene carrito de página y drawer. Se pueden montar
 *      los dos contenedores (#bankame-cart-btn y #bankame-drawer-btn); el
 *      drawer se re-crea entero en cada cambio, así que se re-monta en vez
 *      de solo actualizar details.
 */

(function () {
  "use strict";

  var config     = window.bankameConfig || {};
  var apiKey     = config.apiKey     || "";
  var widgetUrl  = config.widgetUrl  || "";
  var backendUrl = config.backendUrl || "";
  var storeId    = config.storeId    || "";

  var modo = "product"; // "product" | "cart"

  // ═══════════════════════════════════════════════════════════════════
  // Logger centralizado (consola + localStorage + backend)
  // ═══════════════════════════════════════════════════════════════════
  var BANKAME_LOG_KEY       = "bankame_frontend_logs_" + storeId;
  var BANKAME_LOG_MAX_LOCAL = 400;
  var BANKAME_CTX_MAX_CHARS = 6000;

  function recortarContexto(context) {
    if (!context) return null;
    try {
      var s = JSON.stringify(context);
      if (s.length <= BANKAME_CTX_MAX_CHARS) return context;
      return { _truncado: true, _largo: s.length, _muestra: s.slice(0, BANKAME_CTX_MAX_CHARS) };
    } catch (e) {
      return { _noSerializable: String(context) };
    }
  }

  function bankameLog(level, message, context) {
    var entry = {
      timestamp: new Date().toISOString(),
      store_id:  storeId,
      source:    "widget-" + modo,
      level:     (level || "INFO").toUpperCase(),
      message:   String(message || ""),
      context:   recortarContexto(context),
      page_url:  window.location.href
    };
    try {
      var tag = "[Bankame:" + entry.level + "]";
      if (entry.level === "ERROR")                                  console.error(tag, entry.message, entry.context || "");
      else if (entry.level === "WARN" || entry.level === "WARNING") console.warn(tag, entry.message, entry.context || "");
      else                                                          console.log(tag, entry.message, entry.context || "");
    } catch (_) {}
    try {
      var stored = JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]");
      stored.push(entry);
      while (stored.length > BANKAME_LOG_MAX_LOCAL) stored.shift();
      localStorage.setItem(BANKAME_LOG_KEY, JSON.stringify(stored));
    } catch (_) {}
    try {
      if (backendUrl) {
        fetch(backendUrl + "/api/bankame/log-event", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(entry),
          keepalive: true
        }).catch(function () {});
      }
    } catch (_) {}
  }
  window.bankameLog = bankameLog;

  window.bankameDump = function () {
    try {
      return JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]");
    } catch (e) {
      return [];
    }
  };

  var productWidget = null;
  var cartWidgets   = {}; // { containerId: { widget, container, details } }

  var saleData = {
    saleId: null,
    shopifyOrderId: null,
    shopifyOrderNumber: null,
    shopifyOrderName: null,
    totalAmount: null,
    initialPaymentAmount: null,
    flowType: null,
    ordenPromesa: null,
    limpiezaPromesa: null
  };

  // ═══════════════════════════════════════════════════════════════════
  // DIAGNÓSTICO — helpers
  // ═══════════════════════════════════════════════════════════════════

  function detectarFlowType(payload) {
    var p = payload || {};
    return p.flowType || p.flow_type || p.flujo || p.paymentType || p.payment_type || null;
  }

  function resumirPayload(payload) {
    var p = payload || {};
    var claves = [];
    try { claves = Object.keys(p); } catch (e) {}
    return {
      saleId:   p.saleId || p.id || p.sale_id || null,
      flowType: detectarFlowType(p),
      claves:   claves
    };
  }

  function listarMiembros(obj) {
    var out = [];
    if (!obj) return out;
    try {
      for (var k in obj) out.push(k + ":" + typeof obj[k]);
      var proto = Object.getPrototypeOf(obj);
      if (proto && proto !== Object.prototype) {
        Object.getOwnPropertyNames(proto).forEach(function (k) {
          if (out.indexOf(k + ":function") === -1 && k !== "constructor") {
            out.push(k + ":" + typeof obj[k]);
          }
        });
      }
    } catch (e) {}
    return out;
  }

  var CALLBACKS_ESPIA = [
    "onSaleCreated", "onSaleConfirmed", "onSaleCompleted",
    "onCashPayment", "onCashConfirmed", "onDirectPayment", "onDirectPaymentConfirmed",
    "onSuccess", "onComplete", "onCompleted", "onFinish", "onFinished",
    "onOrderCreated", "onOrderConfirmed",
    "onPayment", "onPaymentPending", "onPaymentRejected", "onPaymentFailed",
    "onTransaction", "onTransactionConfirmed",
    "onStatusChange", "onStateChange", "onStep", "onChange", "onUpdate",
    "onQrGenerated", "onVerificationCode",
    "onOpen", "onReady", "onInit", "onClose", "onCancel", "onCancelled"
  ];

  function agregarEspias(opciones) {
    CALLBACKS_ESPIA.forEach(function (nombre) {
      if (typeof opciones[nombre] === "function") return;
      opciones[nombre] = function () {
        var args = [];
        try { args = Array.prototype.slice.call(arguments); } catch (e) {}
        bankameLog("WARN", "SDK disparó un callback NO manejado: " + nombre, {
          resumen: resumirPayload(args[0]),
          payload: args[0],
          argsExtra: args.length > 1 ? args.slice(1) : undefined
        });
      };
    });
    return opciones;
  }

  function instalarSnifferPostMessage() {
    var origenWidget = "";
    try { origenWidget = new URL(widgetUrl).origin; } catch (e) {}

    window.addEventListener("message", function (ev) {
      try {
        if (origenWidget && ev.origin !== origenWidget) return;
        var data = ev.data;
        if (typeof data === "string") {
          try { data = JSON.parse(data); } catch (e) {}
        }
        bankameLog("INFO", "postMessage del widget", {
          origin:   ev.origin,
          tipo:     (data && (data.type || data.event || data.action || data.name)) || typeof data,
          flowType: detectarFlowType(data) || detectarFlowType(data && data.payload),
          data:     data
        });
      } catch (e) {}
    }, false);

    bankameLog("INFO", "Sniffer de postMessage instalado", { origenEscuchado: origenWidget || "(todos)" });
  }

  // ═══════════════════════════════════════════════════════════════════
  // ★ BLOOM BOX — estado de carga del contenedor
  // ═══════════════════════════════════════════════════════════════════
  // El contenedor viene con .is-loading desde el Liquid, así el esqueleto se
  // ve desde el primer pintado y el cliente no mira un hueco vacío mientras
  // baja el SDK. Se saca cuando el widget mete su primer nodo adentro.

  function quitarCargando(container) {
    if (container) container.classList.remove("is-loading");
  }

  function quitarCargandoDeTodos() {
    var nodos = document.querySelectorAll(".bankame-widget-wrapper.is-loading");
    Array.prototype.forEach.call(nodos, quitarCargando);
  }

  function esperarMontajeYQuitarCargando(container) {
    if (!container) return;
    if (container.children.length) return quitarCargando(container);

    var obs = new MutationObserver(function () {
      if (!container.children.length) return;
      obs.disconnect();
      quitarCargando(container);
    });
    obs.observe(container, { childList: true });

    // Red de seguridad: si el SDK no llega a pintar nada, el esqueleto no
    // se queda girando para siempre.
    setTimeout(function () {
      obs.disconnect();
      quitarCargando(container);
    }, 15000);
  }

  // ★ BLOOM BOX — diagnóstico de por qué no aparece window.BankameWidget.
  // Llamable desde la consola: bankameDiagnostico()
  function diagnosticoSDK() {
    var tags = [];
    try {
      tags = Array.prototype.slice
        .call(document.querySelectorAll('script[src*="bankame"]'))
        .map(function (s) { return s.src; });
    } catch (e) {}
    return {
      scriptsBankameEnLaPagina: tags,
      hayTagDelSDK:             tags.join(" ").indexOf("embed") !== -1,
      tipoDeBankameWidget:      typeof window.BankameWidget,
      widgetUrlConfigurado:     widgetUrl,
      backendUrlConfigurado:    backendUrl,
      hayContenedorProducto:    !!document.getElementById("bankame-product-btn"),
      hayContenedorCarrito:     !!document.getElementById("bankame-cart-btn"),
      hayContenedorDrawer:      !!document.getElementById("bankame-drawer-btn")
    };
  }
  window.bankameDiagnostico = diagnosticoSDK;

  // ★ BLOOM BOX — espera al SDK por tiempo, no por frames. Los 50 frames de
  // requestAnimationFrame que heredé de Sarango son menos de un segundo y se
  // congelan con la pestaña en segundo plano: muy poco si el SDK viene de una
  // CDN. Y cuando falla, el log dice QUÉ falta en vez de "no cargó".
  function initWithRetry(initFn, timeoutMs) {
    var limite = Date.now() + (timeoutMs || 10000);
    (function attempt() {
      if (window.BankameWidget) {
        initFn();
      } else if (Date.now() < limite) {
        setTimeout(attempt, 100);
      } else {
        bankameLog("ERROR", "El SDK nunca definió window.BankameWidget", diagnosticoSDK());
        quitarCargandoDeTodos();
      }
    })();
  }

  // ═══════════════════════════════════════════════════════════════════
  // ★ BLOOM BOX — política de envío publicada por el comercio
  // ═══════════════════════════════════════════════════════════════════
  //   Ciudad de Santa Cruz .............. Bs. 15
  //   Otros departamentos ............... Bs. 25
  //   Compras superiores a Bs. 400 ...... gratis, a todo el país
  //
  // Esta tabla es un ESPEJO de lo que está configurado en Shopify, no la
  // fuente de verdad. Se usa solo en la ficha de producto, donde Shopify no
  // puede cotizar (el ítem todavía no está en el carrito y las tarifas
  // dependen del monto). En el carrito manda Shopify y esta tabla sirve de
  // control: si difieren, queda un WARN en el log.
  //
  // SI EL COMERCIO CAMBIA SUS TARIFAS, HAY QUE ACTUALIZAR ESTO A MANO.
  var ENVIO = {
    umbralGratis:    400,
    costoSantaCruz:  15,
    costoOtros:      25,
    nombreSantaCruz: "Santa Cruz",
    nombreOtros:     "Interior del país",
    nombreGratis:    "Envío gratis"
  };

  function esSantaCruz(direccion) {
    var d = direccion || {};
    var txt = ((d.city || "") + " " + (d.state || "")).toLowerCase();
    return txt.indexOf("santa cruz") !== -1;
  }

  // El umbral se evalúa sobre el subtotal CON descuento: es el que ve el
  // cliente en la web y el que usa Shopify para decidir el envío gratis.
  // En cuotas se financia el precio de lista, así que un carrito puede
  // financiar más de 400 y aun así pagar envío. Es a propósito: el envío
  // sigue lo que muestra el sitio, no lo que financia Bankame.
  function calcularEnvioLocal(direccion, subtotalVenta) {
    if (subtotalVenta > ENVIO.umbralGratis) {
      return { name: ENVIO.nombreGratis, price: 0 };
    }
    return esSantaCruz(direccion)
      ? { name: ENVIO.nombreSantaCruz, price: ENVIO.costoSantaCruz }
      : { name: ENVIO.nombreOtros,     price: ENVIO.costoOtros };
  }

  // ═══════════════════════════════════════════════════════════════════
  // ★ BLOOM BOX — precio según el flujo
  // ═══════════════════════════════════════════════════════════════════
  //   'installments'   (cuotas)   -> precio de LISTA, sin descuento
  //   'direct-payment' (contado)  -> precio VIGENTE, con descuento
  // Si el flujo todavía no se conoce se usa el de lista, que es el criterio
  // conservador: nunca financiamos por debajo de lo pactado.
  function precioParaFlujo(flowType, precioListaCents, precioVentaCents) {
    var esContado = flowType && String(flowType).toLowerCase().indexOf("direct") !== -1;
    return esContado ? precioVentaCents : precioListaCents;
  }

  function obtenerInputCantidad() {
    return document.querySelector('form[action*="/cart/add"] input[name="quantity"]')
        || document.querySelector('input[name="quantity"][form]')
        || document.querySelector('input[name="quantity"]');
  }

  function obtenerVariantIdSeleccionada() {
    var el = document.querySelector('form[id^="product-form-"]:not([id*="installment"]) [name="id"]')
          || document.querySelector('form[action*="/cart/add"] [name="id"]')
          || document.querySelector('[name="id"]');
    return el ? el.value : null;
  }

  // ── DATOS FRESCOS DEL PRODUCTO ─────────────────────────────────────
  function obtenerDatosProductoActual(handle, flowType) {
    var variantId = obtenerVariantIdSeleccionada();
    if (!variantId) return Promise.reject(new Error("No hay variante seleccionada"));

    var qtyInput = obtenerInputCantidad();
    var quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

    return fetch("/products/" + handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("Error al obtener datos del producto");
        return res.json();
      })
      .then(function (fullProductData) {
        var currentVariant = fullProductData.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (!currentVariant) throw new Error("Variante no encontrada");
        if (!currentVariant.available) {
          throw new Error("Este producto está agotado y no está disponible para compra con Bankame");
        }

        var compareAt   = currentVariant.compare_at_price || null;
        var precioLista = (compareAt && compareAt > currentVariant.price) ? compareAt : currentVariant.price;
        var precioVenta = currentVariant.price;

        // ★ BLOOM BOX
        var precioFinal = precioParaFlujo(flowType, precioLista, precioVenta);

        bankameLog("INFO", "Precio elegido para la orden", {
          flowType:    flowType,
          precioLista: precioLista / 100,
          precioVenta: precioVenta / 100,
          usado:       precioFinal / 100
        });

        var producto = {
          variant_id:    String(variantId),
          product_id:    String(fullProductData.id),
          product_title: fullProductData.title,
          variant_title: currentVariant.title || "Default",
          quantity:      quantity,
          price:         (parseFloat(precioFinal) / 100).toFixed(2),
          line_price:    (parseFloat(precioFinal) / 100 * quantity).toFixed(2),
          sku:           currentVariant.sku || "",
          handle:        handle
        };

        bankameLog("INFO", "Datos del producto obtenidos", producto);
        return {
          items: [producto],
          // Subtotal CON descuento: es el que decide el envío gratis.
          subtotalVenta: (precioVenta / 100) * quantity
        };
      });
  }

  // ── DATOS FRESCOS DEL CARRITO ──────────────────────────────────────
  // /cart.js no devuelve compare_at_price: se completa con /products/{handle}.js.
  function obtenerDatosCarritoActual(flowType) {
    return fetch("/cart.js")
      .then(function (res) {
        if (!res.ok) throw new Error("Error al obtener el carrito");
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) throw new Error("El carrito está vacío");

        var handles = [];
        cart.items.forEach(function (item) {
          if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });

        return Promise.all(
          handles.map(function (h) {
            return fetch("/products/" + h + ".js")
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          })
        ).then(function (productos) {
          var comparePorVariante = {};
          productos.forEach(function (p) {
            if (!p || !p.variants) return;
            p.variants.forEach(function (v) {
              comparePorVariante[String(v.id)] = v.compare_at_price || null;
            });
          });
          return { cart: cart, comparePorVariante: comparePorVariante };
        });
      })
      .then(function (data) {
        var items   = [];
        var details = [];

        data.cart.items.forEach(function (item) {
          var variantId   = String(item.variant_id || item.id);
          var precioVenta = item.final_price;
          var compareAt   = data.comparePorVariante[variantId];
          var precioLista = (compareAt && compareAt > precioVenta) ? compareAt : precioVenta;

          // ★ BLOOM BOX
          var precioFinal = precioParaFlujo(flowType, precioLista, precioVenta);

          items.push({
            variant_id:    variantId,
            product_id:    String(item.product_id),
            product_title: item.product_title || item.title,
            variant_title: item.variant_title || "Default",
            quantity:      item.quantity,
            price:         (parseFloat(precioFinal) / 100).toFixed(2),
            line_price:    (parseFloat(precioFinal) / 100 * item.quantity).toFixed(2),
            sku:           item.sku || "",
            handle:        item.handle || ""
          });

          details.push({
            product:       item.product_title || item.title,
            unitPrice:     Math.round(precioLista / 100),
            discountPrice: Math.round(precioVenta / 100),
            quantity:      item.quantity
          });
        });

        bankameLog("INFO", "Datos del carrito obtenidos", {
          flowType:    flowType,
          lineas:      items.length,
          total_price: data.cart.total_price / 100
        });

        return {
          items: items,
          details: details,
          subtotalVenta: data.cart.total_price / 100
        };
      });
  }

  // ═══════════════════════════════════════════════════════════════════
  // ★ BLOOM BOX — resolución del costo de envío
  // ═══════════════════════════════════════════════════════════════════

  function consultarEnvioShopify(direccion) {
    var d = direccion || {};
    var qs = new URLSearchParams();
    qs.set("shipping_address[country]", "Bolivia");
    if (d.state) qs.set("shipping_address[province]", d.state);
    if (d.city)  qs.set("shipping_address[city]", d.city);
    qs.set("shipping_address[zip]", d.zip || "");

    return fetch("/cart/shipping_rates.json?" + qs.toString(), {
      headers: { Accept: "application/json" }
    })
      .then(function (r) {
        if (!r.ok) throw new Error("shipping_rates " + r.status);
        return r.json();
      })
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        if (!rates.length) return null;
        var elegida = rates.reduce(function (a, b) {
          return parseFloat(b.price) < parseFloat(a.price) ? b : a;
        });
        return { name: elegida.name, price: parseFloat(elegida.price) };
      })
      .catch(function (e) {
        bankameLog("WARN", "No se pudo consultar el envío a Shopify: " + e.message, { direccion: d });
        return null;
      });
  }

  function resolverEnvio(direccion, subtotalVenta, esCarrito) {
    var local = calcularEnvioLocal(direccion, subtotalVenta);

    // Ficha de producto: Shopify cotizaría sobre el carrito actual, que no
    // contiene este producto. Como las tarifas dependen del monto, ese número
    // sería directamente otro. Manda la tabla local.
    if (!esCarrito) {
      bankameLog("INFO", "Envío resuelto localmente (ficha de producto)", {
        subtotalVenta: subtotalVenta, tarifa: local
      });
      return Promise.resolve(local);
    }

    return consultarEnvioShopify(direccion).then(function (shopify) {
      if (!shopify) {
        bankameLog("WARN", "Shopify no devolvió tarifas — se usa la tabla local", {
          direccion: direccion, tarifa: local
        });
        return local;
      }
      if (Math.abs(shopify.price - local.price) > 0.001) {
        // La configuración de Shopify y la política publicada se separaron.
        // Gana Shopify, pero queda registrado para que alguien lo revise.
        bankameLog("WARN", "El envío de Shopify no coincide con la política publicada", {
          shopify: shopify, local: local, subtotalVenta: subtotalVenta, direccion: direccion
        });
      }
      bankameLog("INFO", "Envío resuelto por Shopify", {
        subtotalVenta: subtotalVenta, tarifa: shopify
      });
      return shopify;
    });
  }

  // ── VACIAR EL CARRITO TRAS LA COMPRA ───────────────────────────────
  function vaciarCarritoShopify(esCarrito) {
    if (!esCarrito) return Promise.resolve();

    if (!saleData.shopifyOrderId) {
      bankameLog("WARN", "No se vacía el carrito: la orden no se creó en Shopify", {
        flowType: saleData.flowType,
        saleId:   saleData.saleId
      });
      return Promise.resolve();
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    return fetch(root + "cart/clear.js", {
      method:    "POST",
      headers:   { "Content-Type": "application/json" },
      keepalive: true
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) {
            bankameLog("ERROR", "cart/clear.js falló", { status: r.status, body: j });
            return;
          }
          bankameLog("INFO", "Carrito vaciado tras el pago", {
            item_count:       j.item_count,
            shopify_order_id: saleData.shopifyOrderId,
            flowType:         saleData.flowType
          });
        });
      })
      .catch(function (e) {
        bankameLog("ERROR", "Excepción al vaciar el carrito: " + e.message);
      });
  }

  function calcularTotales(productos, costoEnvio) {
    var subtotal = productos.reduce(function (sum, p) {
      return sum + parseFloat(p.line_price);
    }, 0);
    var envio = parseFloat(costoEnvio) || 0;
    var total = subtotal + envio;
    return {
      subtotal:     subtotal.toFixed(2),
      costoEnvio:   envio.toFixed(2),
      total:        total.toFixed(2),
      cuotaInicial: (total / 2).toFixed(2)
    };
  }

  function obtenerDatosCliente(payload, container) {
    var liquidCustomer = {};
    try {
      liquidCustomer = JSON.parse(container.getAttribute("data-customer")) || {};
    } catch (e) {
      liquidCustomer = {};
    }

    var p  = payload || {};
    var wc = p.customer || p.client || p.cliente || {};
    var wcAddress = wc.address || wc.shippingAddress || {};
    var sd = p.shippingData || p.shipping_data || {};

    var firstName = p.shippingClientName     || sd.shippingClientName
                 || wc.firstName || wc.first_name || wc.firstname || wc.name
                 || liquidCustomer.first_name || "Cliente";
    var lastName  = p.shippingClientLastName || sd.shippingClientLastName
                 || wc.lastName  || wc.last_name || wc.lastname
                 || liquidCustomer.last_name || "Bankame";
    var email     = p.shippingEmail          || sd.shippingEmail
                 || wc.email || liquidCustomer.email || "";
    var phone     = p.shipingPhoneNumber || p.shippingPhoneNumber
                 || sd.shipingPhoneNumber || sd.shippingPhoneNumber
                 || wc.phone || wc.phone_number || wc.phoneNumber
                 || liquidCustomer.phone || "";
    var street    = p.shippingAddress        || sd.shippingAddress
                 || wcAddress.street || wcAddress.address1 || wc.address
                 || liquidCustomer.address1 || "";
    var city      = p.shippingCity           || sd.shippingCity
                 || wcAddress.city   || wc.city || liquidCustomer.city || "";
    var state     = p.shippingDepartment     || sd.shippingDepartment
                 || wcAddress.state  || wcAddress.province || wc.department
                 || liquidCustomer.province || "";

    var cliente = {
      email:      email,
      first_name: firstName,
      last_name:  lastName,
      phone:      phone,
      address: { street: street, city: city, state: state, country: "BO" }
    };

    bankameLog("INFO", "Datos de cliente resueltos", {
      cliente: cliente,
      origen: {
        habiaCustomerEnPayload: !!(p.customer || p.client || p.cliente),
        habiaShippingData:      !!(p.shippingData || p.shipping_data),
        habiaCustomerLiquid:    Object.keys(liquidCustomer).length > 0
      }
    });

    return cliente;
  }

  // ═══════════════════════════════════════════════════════════════════
  // 1) Crear orden PENDIENTE en Shopify + vincularla a la venta Bankame
  // ═══════════════════════════════════════════════════════════════════
  function crearOrdenPendienteYVincular(payload, container, handle, esCarrito) {
    var flowType = saleData.flowType;

    bankameLog("INFO", "Creando orden pendiente en Shopify", {
      origen: esCarrito ? "cart" : "product", flowType: flowType, saleId: saleData.saleId
    });

    var cliente = obtenerDatosCliente(payload, container);

    var fuenteItems = esCarrito
      ? obtenerDatosCarritoActual(flowType)
      : obtenerDatosProductoActual(handle, flowType);

    // ★ BLOOM BOX — el envío depende del monto, así que hay que conocer el
    // subtotal antes de cotizarlo: primero los ítems, después el envío.
    return fuenteItems
      .then(function (datos) {
        return resolverEnvio(cliente.address, datos.subtotalVenta, esCarrito)
          .then(function (tarifa) {
            return { productos: datos.items, tarifa: tarifa };
          });
      })
      .then(function (res) {
        var productos = res.productos;
        var tarifa    = res.tarifa;

        var shippingMethod = tarifa
          ? tarifa.name
          : ((payload && (payload.shippingMethod || payload.shipping_method)) || "Por coordinar (Bankame Widget)");
        var shippingCost = tarifa
          ? tarifa.price
          : ((payload && (payload.shippingCost || payload.shipping_cost)) || 0);

        var totales = calcularTotales(productos, shippingCost);
        saleData.totalAmount          = totales.total;
        saleData.initialPaymentAmount = totales.cuotaInicial;

        bankameLog("INFO", "Totales calculados", {
          flowType:      flowType,
          origenEnvio:   tarifa ? "shopify" : "payload/fallback",
          totales:       totales
        });

        var orderData = {
          customer:               cliente,
          shipping_address:       cliente.address,
          store_id:               storeId,
          shipping_method:        shippingMethod,
          shipping_cost:          totales.costoEnvio,
          items:                  productos,
          total_amount:           totales.total,
          initial_payment_amount: totales.cuotaInicial
        };

        bankameLog("INFO", "create-pending-order → enviando", {
          store_id: storeId, flowType: flowType,
          total: totales.total, items: productos.length, body: orderData
        });

        return fetch(backendUrl + "/api/bankame/create-pending-order", {
          method:  "POST",
          headers: { "Content-Type": "application/json", "X-Store-Id": storeId },
          body:    JSON.stringify(orderData)
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            bankameLog("ERROR", "create-pending-order falló", { status: response.status, body: errorData });
            throw new Error(errorData.error || ("Error " + response.status));
          });
        }
        return response.json();
      })
      .then(function (result) {
        bankameLog("INFO", "create-pending-order OK — Shopify order creada", {
          shopify_order_id:     result.shopify_order_id,
          shopify_order_number: result.shopify_order_number,
          shopify_order_name:   result.shopify_order_name,
          respuestaCompleta:    result
        });

        saleData.shopifyOrderId     = result.shopify_order_id;
        saleData.shopifyOrderNumber = result.shopify_order_number;
        saleData.shopifyOrderName   = result.shopify_order_name;

        if (result.order_status_url || result.order_url) {
          window._bankameOrderUrl = result.order_status_url || result.order_url;
        }

        return vincularOrdenConBankame(result.shopify_order_id, saleData.saleId);
      });
  }

  function vincularOrdenConBankame(shopifyOrderId, bankameSaleId) {
    bankameLog("INFO", "link-order → enviando", {
      shopify_order_id: shopifyOrderId, bankame_sale_id: bankameSaleId, store_id: storeId
    });

    if (!shopifyOrderId || !bankameSaleId) {
      bankameLog("ERROR", "link-order abortado: shopify_order_id o bankame_sale_id vacío", {
        shopifyOrderId: shopifyOrderId, bankameSaleId: bankameSaleId, flowType: saleData.flowType
      });
      return Promise.resolve();
    }

    return fetch(backendUrl + "/api/bankame/link-order", {
      method:  "POST",
      headers: { "Content-Type": "application/json", "X-Store-Id": storeId },
      body:    JSON.stringify({
        shopify_order_id: shopifyOrderId,
        bankame_sale_id:  bankameSaleId,
        store_id:         storeId
      })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (j) {
          if (!response.ok || j.success === false) {
            bankameLog("ERROR", "link-order respondió error", { status: response.status, body: j });
          } else {
            bankameLog("INFO", "link-order OK", j);
          }
        });
      })
      .catch(function (error) {
        bankameLog("ERROR", "link-order excepción: " + error.message);
      });
  }

  // ═══════════════════════════════════════════════════════════════════
  // 2) Marcar la orden como PAGADA
  // ═══════════════════════════════════════════════════════════════════
  function notificarPagoConfirmado(bankameTransactionId) {
    var requestBody = {
      bankame_transaction_id: bankameTransactionId,
      store_id:               storeId,
      shopify_order_id:       saleData.shopifyOrderId,
      total_amount:           saleData.totalAmount,
      initial_payment_amount: saleData.initialPaymentAmount,
      payment_date:           new Date().toISOString(),
      payment_method:         "QR",
      payment_reference:      "QR-" + Date.now()
    };

    if (!saleData.shopifyOrderId) {
      bankameLog("ERROR", "payment-confirmed SIN shopify_order_id — la orden no existe en Shopify", {
        flowType: saleData.flowType, saleId: bankameTransactionId, saleData: saleData
      });
    }

    bankameLog("INFO", "payment-confirmed → enviando", { flowType: saleData.flowType, body: requestBody });

    return fetch(backendUrl + "/api/bankame/payment-confirmed", {
      method:  "POST",
      headers: { "Content-Type": "application/json", "X-Store-Id": storeId },
      body:    JSON.stringify(requestBody)
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.success === false) {
            bankameLog("WARN", "payment-confirmed respondió error (webhook debería resolver)", {
              status: response.status, body: data
            });
            return data;
          }
          bankameLog("INFO", "payment-confirmed OK", data);
          return data;
        });
      })
      .catch(function (error) {
        bankameLog("WARN", "payment-confirmed excepción (webhook debería resolver): " + error.message);
      });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Callbacks del SDK — compartidos entre producto y carrito
  // ═══════════════════════════════════════════════════════════════════
  function construirCallbacks(container, handle, esCarrito) {
    return {
      onClientConfirmed: function (payload) {
        bankameLog("INFO", "SDK onClientConfirmed", resumirPayload(payload));
        bankameLog("INFO", "Payload COMPLETO del widget (onClientConfirmed)", payload);

        var currentSaleId = (payload && (payload.saleId || payload.id)) || null;

        if (currentSaleId && window._bankameOrderCreatedForSaleId === currentSaleId) {
          bankameLog("INFO", "Orden ya creada para saleId — ignorando duplicado", { saleId: currentSaleId });
          return;
        }

        window._bankameOrderCreatedForSaleId = currentSaleId;
        window._bankamePaymentConfirmedFor   = null;
        window._bankameOrderUrl              = null;
        if (redirectTimer) { clearTimeout(redirectTimer); redirectTimer = null; }
        pendingRedirectUrl = null;

        saleData.saleId               = currentSaleId;
        saleData.shopifyOrderId       = null;
        saleData.shopifyOrderNumber   = null;
        saleData.shopifyOrderName     = null;
        saleData.totalAmount          = null;
        saleData.initialPaymentAmount = null;
        saleData.flowType             = detectarFlowType(payload);
        saleData.ordenPromesa         = null;
        saleData.limpiezaPromesa      = null;

        saleData.ordenPromesa = crearOrdenPendienteYVincular(payload, container, handle, esCarrito)
          .catch(function (error) {
            bankameLog("ERROR", "Error al crear la orden pendiente: " + error.message);
            window._bankameOrderCreatedForSaleId = null;
            window._bankameOrderUrl = (config.shopUrl || "/") + "?bankame_sale=" + (saleData.saleId || "");
          });
      },

      onPaymentConfirmed: function (payload) {
        bankameLog("INFO", "SDK onPaymentConfirmed", resumirPayload(payload));
        bankameLog("INFO", "Payload COMPLETO del widget (onPaymentConfirmed)", payload);

        var transactionId = (payload && (payload.saleId || payload.id)) || saleData.saleId;
        var flowType      = detectarFlowType(payload) || saleData.flowType;
        saleData.flowType = flowType;

        if (transactionId && window._bankamePaymentConfirmedFor === transactionId) {
          bankameLog("INFO", "Pago ya confirmado para saleId — ignorando duplicado", { saleId: transactionId });
          return;
        }
        window._bankamePaymentConfirmedFor = transactionId;

        var marcarPagada = function () {
          if (!transactionId) {
            bankameLog("ERROR", "No hay saleId para confirmar el pago", { payload: payload });
            return;
          }
          return notificarPagoConfirmado(transactionId).catch(function (error) {
            bankameLog("ERROR", "Error al actualizar Shopify como pagada: " + error.message);
          });
        };

        if (saleData.ordenPromesa) {
          bankameLog("INFO", "Hay orden en curso — se espera antes de marcar pagada", {
            flowType: flowType, saleId: transactionId
          });
          saleData.ordenPromesa.then(marcarPagada, marcarPagada);
        } else {
          // FALLBACK — flujo AL CONTADO: el widget confirma el pago sin pasar
          // por onClientConfirmed, así que la orden se crea recién acá.
          // Como saleData.flowType ya quedó seteado arriba, la orden se crea
          // con el precio CON descuento, que es lo que corresponde al contado.
          bankameLog("WARN", "onPaymentConfirmed SIN orden previa — creando la orden ahora (probable flujo al contado)", {
            flowType: flowType, saleId: transactionId, origen: esCarrito ? "cart" : "product"
          });

          saleData.saleId                      = saleData.saleId || transactionId;
          window._bankameOrderCreatedForSaleId = transactionId;

          saleData.ordenPromesa = crearOrdenPendienteYVincular(payload, container, handle, esCarrito)
            .catch(function (error) {
              bankameLog("ERROR", "No se pudo crear la orden en el flujo al contado: " + error.message);
              window._bankameOrderCreatedForSaleId = null;
            });

          saleData.ordenPromesa.then(marcarPagada, marcarPagada);
        }

        var limpiar = function () { return vaciarCarritoShopify(esCarrito); };
        saleData.limpiezaPromesa = saleData.ordenPromesa
          ? saleData.ordenPromesa.then(limpiar, limpiar)
          : limpiar();

        if (pendingRedirectUrl) return;
        var url = (config.shopUrl || "/") + "?bankame_sale=" + (transactionId || "");
        if (window._bankameOrderUrl) url = window._bankameOrderUrl;
        esperarCierreYRedirigir(url);
      },

      onError: function (error) {
        bankameLog("ERROR", "SDK reportó error: " + (error && error.message), {
          error: error, flowType: saleData.flowType, saleData: saleData
        });
      }
    };
  }

  // ── PRODUCTO INDIVIDUAL ────────────────────────────────────────────
  function initProductWidget() {
    var container = document.getElementById("bankame-product-btn");
    if (!container) return;

    var handle = container.getAttribute("data-handle") || "";

    var details = [];
    try {
      details = JSON.parse(container.getAttribute("data-product")) || [];
    } catch (e) {
      bankameLog("ERROR", "Error al leer data-product: " + e.message);
      return;
    }

    var preciosPorVariante = {};
    try {
      preciosPorVariante = JSON.parse(container.getAttribute("data-variants")) || {};
    } catch (e) {
      preciosPorVariante = {};
    }

    bankameLog("INFO", "Details enviados al widget (init)", details);

    var opciones = agregarEspias(construirCallbacks(container, handle, false));
    opciones.widgetUrl = widgetUrl;
    opciones.apiKey    = apiKey;
    opciones.details   = details;
    opciones.target    = "#bankame-product-btn";

    productWidget = window.BankameWidget.init(opciones);
    esperarMontajeYQuitarCargando(container);

    bankameLog("INFO", "SDK inicializado (producto)", {
      instancia: listarMiembros(productWidget),
      global:    listarMiembros(window.BankameWidget)
    });

    var lastQty       = 1;
    var lastVariantId = obtenerVariantIdSeleccionada();
    setInterval(function () {
      if (!productWidget) return;
      var cambio = false;

      var qtyInput = obtenerInputCantidad();
      if (qtyInput) {
        var qty = parseInt(qtyInput.value) || 1;
        if (qty !== lastQty) {
          lastQty = qty;
          details[0].quantity = qty;
          cambio = true;
          bankameLog("INFO", "Cantidad actualizada", { qty: qty });
        }
      }

      var variantId = obtenerVariantIdSeleccionada();
      if (variantId && variantId !== lastVariantId) {
        lastVariantId = variantId;
        var precioVar = preciosPorVariante[variantId];
        if (precioVar) {
          // Variante agotada: no se ofrece compra por Bankame.
          container.style.display = precioVar.available === false ? "none" : "";

          if (precioVar.unitPrice !== details[0].unitPrice || precioVar.discountPrice !== details[0].discountPrice) {
            details[0].unitPrice     = precioVar.unitPrice;
            details[0].discountPrice = precioVar.discountPrice;
            cambio = true;
            bankameLog("INFO", "Precio actualizado por variante", {
              variantId: variantId,
              unitPrice: precioVar.unitPrice,
              discountPrice: precioVar.discountPrice
            });
          }
        }
      }

      if (cambio) {
        if (typeof productWidget.updateDetails === "function") {
          productWidget.updateDetails(JSON.parse(JSON.stringify(details)));
        } else {
          bankameLog("WARN", "El SDK no expone updateDetails — datos frescos se envían al confirmar.");
        }
      }
    }, 300);
  }

  // ── CARRITO (página y drawer) ──────────────────────────────────────
  // ★ BLOOM BOX: el tema puede tener los dos. El drawer se re-renderiza
  // entero, así que su contenedor es un elemento NUEVO cada vez y hay que
  // volver a montar el widget, no solo actualizar details.
  var CART_CONTAINERS = ["bankame-cart-btn", "bankame-drawer-btn"];

  function montarCarrito(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var previo = cartWidgets[containerId];
    if (previo && previo.container === container) return; // ya montado sobre este nodo

    if (previo && previo.widget && typeof previo.widget.destroy === "function") {
      try { previo.widget.destroy(); } catch (e) {}
    }

    var details = [];
    try {
      details = JSON.parse(container.getAttribute("data-product")) || [];
    } catch (e) {
      bankameLog("ERROR", "Error al leer data-product de " + containerId + ": " + e.message);
      return;
    }

    if (details.length === 0) {
      quitarCargando(container);
      container.style.display = "none";
      bankameLog("INFO", "Carrito sin ítems — no se monta " + containerId);
      delete cartWidgets[containerId];
      return;
    }
    container.style.display = "";

    var opciones = agregarEspias(construirCallbacks(container, null, true));
    opciones.widgetUrl = widgetUrl;
    opciones.apiKey    = apiKey;
    opciones.details   = details;
    opciones.target    = "#" + containerId;

    var widget = window.BankameWidget.init(opciones);
    esperarMontajeYQuitarCargando(container);
    cartWidgets[containerId] = { widget: widget, container: container, details: details };

    bankameLog("INFO", "SDK inicializado (" + containerId + ")", {
      lineas:    details.length,
      instancia: listarMiembros(widget)
    });
  }

  function initCartWidget() {
    CART_CONTAINERS.forEach(montarCarrito);

    if (!Object.keys(cartWidgets).length) {
      bankameLog("WARN", "No se montó ningún widget de carrito — revisá que el snippet esté renderizado.");
    }

    // ── Re-sincronización cuando cambia el carrito ───────────────────
    var refrescoPendiente = null;

    function refrescarCarrito() {
      // Tras el pago el carrito queda vacío a propósito: no hay que
      // reaccionar a ese cambio mientras el cliente ve la confirmación.
      if (saleData.limpiezaPromesa) return;

      if (refrescoPendiente) clearTimeout(refrescoPendiente);
      refrescoPendiente = setTimeout(function () {
        refrescoPendiente = null;

        // El drawer se re-renderiza entero: si el nodo cambió, re-montar.
        CART_CONTAINERS.forEach(montarCarrito);

        // El de la página de carrito sobrevive al re-render (vive fuera del
        // .js-contents que reemplaza Dawn), así que sus details se refrescan.
        obtenerDatosCarritoActual(saleData.flowType)
          .then(function (r) {
            Object.keys(cartWidgets).forEach(function (id) {
              var entry = cartWidgets[id];
              entry.container.style.display = r.details.length ? "" : "none";

              entry.details.length = 0;
              r.details.forEach(function (d) { entry.details.push(d); });

              if (entry.widget && typeof entry.widget.updateDetails === "function") {
                entry.widget.updateDetails(JSON.parse(JSON.stringify(entry.details)));
              }
            });
            bankameLog("INFO", "Details del carrito actualizados", { lineas: r.details.length });
          })
          .catch(function (error) {
            Object.keys(cartWidgets).forEach(function (id) {
              cartWidgets[id].container.style.display = "none";
            });
            bankameLog("WARN", "No se pudo refrescar el carrito: " + error.message);
          });
      }, 250);
    }

    document.addEventListener("bankame:cart-updated", refrescarCarrito);

    try {
      if (typeof subscribe === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        subscribe(window.PUB_SUB_EVENTS.cartUpdate, refrescarCarrito);
      }
    } catch (e) {
      bankameLog("WARN", "No se pudo suscribir a PUB_SUB_EVENTS.cartUpdate: " + e.message);
    }

    // Red de seguridad: Dawn reemplaza el .js-contents del footer y el
    // .drawer__inner del drawer sin avisar de forma estable entre versiones.
    ["main-cart-footer", "CartDrawer"].forEach(function (id) {
      var root = document.getElementById(id);
      if (!root) return;
      new MutationObserver(refrescarCarrito).observe(root, { childList: true, subtree: true });
    });
  }

  // ── ESPERAR CIERRE DEL POPUP PARA REDIRIGIR ────────────────────────
  var pendingRedirectUrl = null;
  var redirectTimer      = null;

  function esperarCierreYRedirigir(orderUrl) {
    if (redirectTimer) clearTimeout(redirectTimer);
    pendingRedirectUrl = orderUrl;
    redirectTimer = setTimeout(function () {
      var irA = function () {
        var url = window._bankameOrderUrl || pendingRedirectUrl;
        pendingRedirectUrl = null;
        redirectTimer      = null;
        bankameLog("INFO", "Redirigiendo tras el pago", { url: url, saleData: saleData });
        if (url) window.location.href = url;
      };

      var pendientes = [];
      if (saleData.ordenPromesa)    pendientes.push(saleData.ordenPromesa);
      if (saleData.limpiezaPromesa) pendientes.push(saleData.limpiezaPromesa);

      if (pendientes.length) {
        Promise.all(pendientes.map(function (p) { return p.catch(function () {}); })).then(irA, irA);
      } else {
        irA();
      }
    }, 4000);
  }

  window.addEventListener("beforeunload", function () {
    if (productWidget) productWidget.destroy();
    Object.keys(cartWidgets).forEach(function (id) {
      var w = cartWidgets[id].widget;
      if (w && typeof w.destroy === "function") w.destroy();
    });
  });

  // ═══════════════════════════════════════════════════════════════════
  // Panel flotante de logs (activar con ?bankame_logs=1)
  // ═══════════════════════════════════════════════════════════════════
  function renderBankameLogsPanel() {
    var url = new URL(window.location.href);
    var localOn    = url.searchParams.get("bankame_logs") === "1";
    var shortcutOn = localStorage.getItem("bankame_show_logs") === "1";
    if (!localOn && !shortcutOn) return;
    if (document.getElementById("bankameLogsPanel")) return;

    var panel = document.createElement("div");
    panel.id = "bankameLogsPanel";
    panel.style.cssText = "position:fixed;bottom:12px;right:12px;width:520px;max-width:95vw;height:360px;max-height:70vh;background:#0d1117;color:#e6edf3;border:1px solid #30363d;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,.4);z-index:2147483647;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:12px;display:flex;flex-direction:column;overflow:hidden;";

    var header = document.createElement("div");
    header.style.cssText = "padding:8px 12px;background:#161b22;border-bottom:1px solid #30363d;display:flex;justify-content:space-between;align-items:center;font-weight:600;";
    header.innerHTML = "<span>📋 Bankame Logs — " + storeId + " / widget-" + modo + "</span>";

    var btns = document.createElement("div");
    btns.style.cssText = "display:flex;gap:6px;";
    var mkBtn = function (t, on) {
      var b = document.createElement("button");
      b.textContent = t;
      b.style.cssText = "background:#21262d;color:#e6edf3;border:1px solid #30363d;padding:3px 8px;border-radius:4px;cursor:pointer;font-size:11px;";
      b.onclick = on;
      return b;
    };
    btns.appendChild(mkBtn("🔄 Refrescar", function () { renderList(); }));
    btns.appendChild(mkBtn("🌐 Backend", function () {
      fetch(backendUrl + "/api/bankame/logs?store_id=" + storeId + "&limit=100")
        .then(function (r) { return r.json(); })
        .then(function (j) { renderList((j.logs || []).slice().reverse(), "backend"); })
        .catch(function (e) { alert("Error backend: " + e.message); });
    }));
    btns.appendChild(mkBtn("📋 Copiar", function () {
      try {
        var txt = localStorage.getItem(BANKAME_LOG_KEY) || "[]";
        navigator.clipboard.writeText(txt);
        alert("Logs copiados al portapapeles (" + JSON.parse(txt).length + " entradas)");
      } catch (e) { alert("No se pudo copiar: " + e.message); }
    }));
    btns.appendChild(mkBtn("🗑 Limpiar", function () { localStorage.removeItem(BANKAME_LOG_KEY); renderList(); }));
    btns.appendChild(mkBtn("✕", function () { panel.remove(); localStorage.removeItem("bankame_show_logs"); }));
    header.appendChild(btns);
    panel.appendChild(header);

    var list = document.createElement("div");
    list.style.cssText = "flex:1;overflow-y:auto;padding:8px 12px;";
    panel.appendChild(list);
    document.body.appendChild(panel);

    function renderList(externalLogs, source) {
      var logs = externalLogs || JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]").slice().reverse();
      if (logs.length === 0) {
        list.innerHTML = '<em style="color:#8b949e;">Sin logs ' + (source ? "(" + source + ")" : "(local)") + "</em>";
        return;
      }
      list.innerHTML = "";
      logs.forEach(function (e) {
        var row = document.createElement("div");
        var colors = { ERROR: "#f85149", WARN: "#d29922", WARNING: "#d29922", INFO: "#58a6ff", DEBUG: "#8b949e" };
        var c = colors[e.level] || "#e6edf3";
        row.style.cssText = "padding:5px 0;border-bottom:1px solid #21262d;";
        var ctx = e.context ? '<div style="color:#8b949e;font-size:11px;margin-top:2px;white-space:pre-wrap;">' + JSON.stringify(e.context) + "</div>" : "";
        row.innerHTML = '<div><span style="color:#8b949e;">' + (e.timestamp || "") + '</span> <b style="color:' + c + ';">[' + (e.level || "INFO") + "]</b> " + (e.message || "") + "</div>" + ctx;
        list.appendChild(row);
      });
    }
    renderList();
  }
  window.mostrarBankameLogs = function () {
    localStorage.setItem("bankame_show_logs", "1");
    renderBankameLogsPanel();
  };

  // ── Punto de entrada ───────────────────────────────────────────────
  document.addEventListener("DOMContentLoaded", function () {
    if (!apiKey || !widgetUrl) {
      bankameLog("WARN", "API Key o Widget URL no configurados.");
      return;
    }
    if (!backendUrl || !storeId || storeId === "NUEVO_STORE_ID") {
      bankameLog("WARN", "backendUrl o storeId no configurados — las órdenes NO se crearán en Shopify.");
    }

    var hayProducto = !!document.getElementById("bankame-product-btn");
    modo = (hayProducto && config.isProduct === "yes") ? "product" : "cart";

    bankameLog("INFO", "Bankame widget iniciado", {
      version: "1.0.0-bloombox", storeId: storeId, modo: modo, isProduct: config.isProduct
    });

    instalarSnifferPostMessage();
    renderBankameLogsPanel();

    // ★ BLOOM BOX — el drawer se renderiza en TODAS las páginas, así que en la
    // ficha de producto hay que montar los dos. Si no, el cliente agrega al
    // carrito, abre el drawer y se queda sin forma de pagar: el botón de
    // checkout ya no está.
    if (document.getElementById("bankame-product-btn")) {
      initWithRetry(initProductWidget);
    }
    if (document.getElementById("bankame-cart-btn") || document.getElementById("bankame-drawer-btn")) {
      initWithRetry(initCartWidget);
    }
  });

})();